import { HttpClient } from '@angular/common/http';
import { inject } from '@angular/core';
import { ENVIRONMENT } from '@interacta-shared/data-access-configuration';
import { MultiTranslateHttpLoader } from '@interacta-shared/util';

export function translateHttpLoaderFactory(): MultiTranslateHttpLoader {
    const env = inject(ENVIRONMENT);
    return new MultiTranslateHttpLoader(inject(HttpClient), [
        { prefix: './assets/ui/i18n/', suffix: '.json' },
        { prefix: './assets/shared/i18n/', suffix: '.json' },
        { prefix: './assets/i18n/', suffix: '.json' },
        {
            prefix: `${env.apiBasePath.common}/core/settings/labels/interacta_webapp/`,
            suffix: '',
            dynamic: true,
        },
    ]);
}
